import { useFormikContext } from 'formik'
import { useEffect } from 'react'
import { HO_SO_BENH_AN_FORM } from 'src/app/modules/phan-he-noi-tru-dieu-tri/components/benh-an/components/content/components/thong-tin-benh-an/components/ho-so-benh-an/constant'
import { useDetailHoSoBenhAn } from 'src/app/modules/phan-he-noi-tru-dieu-tri/components/benh-an/components/content/components/thong-tin-benh-an/components/ho-so-benh-an/hook'
import { usePhanHeDieuTriNoiTruContext } from 'src/app/modules/phan-he-noi-tru-dieu-tri/PhanHeDieuTriContext'
import { generateInitValues, generateValidationSchema } from 'src/app/modules/utils/AppFunction'
import GenerateFormHTMLNoValid from '../../../../component/generate-form/GenerateFormHTMLNoValid'
import CustomComponent from '../../../../phan-he-noi-tru-dieu-tri/components/benh-an/components/content/components/thong-tin-benh-an/components/phieu-dieu-tri/components/CustomComponent'
import useFormIO from '../../../../phan-he-noi-tru-dieu-tri/components/benh-an/hooks/useFormIO'
import { CODE_GENERATE_FORM } from '../../../../utils/Constant'

type Props = {
    setValidationSchema: React.Dispatch<any>;
}

const ThongTinRaVien = ({ setValidationSchema }: Props) => {
    const { values, setFieldValue, errors, touched } = useFormikContext<any>();
    const { benhNhanDieuTri } = usePhanHeDieuTriNoiTruContext();
    const { formJSON } = useFormIO({
        code: CODE_GENERATE_FORM.xuTriRaVien,
    });
    const { data } = useDetailHoSoBenhAn({
        medicalRecordId: benhNhanDieuTri?.medicalRecordId,
        formName: HO_SO_BENH_AN_FORM.TRANG_TONG_KET,
    });
    
    useEffect(() => {
        const initValues = generateInitValues(formJSON);
        const initKeys = Object.keys(initValues);
        const filteredData = data
            ? Object.fromEntries(
                Object.entries(data).filter(([key]) => initKeys.includes(key))
            )
            : {};

        setFieldValue(CODE_GENERATE_FORM.xuTriRaVien, {
            ...initValues,
            ...values[CODE_GENERATE_FORM.xuTriRaVien],
            ...filteredData,
        });
        setValidationSchema(generateValidationSchema(formJSON, CODE_GENERATE_FORM.xuTriRaVien));
    }, [formJSON, data]);

    return (
        <div className="spaces p-10 h-calc-vh-250 overflow-auto">
            <GenerateFormHTMLNoValid
                listFieldAuto={formJSON}
                isSave={false}
                isUpdate={true}
                values={values}
                setFieldValue={setFieldValue}
                errors={errors}
                touched={touched}
                modelID={CODE_GENERATE_FORM.xuTriRaVien}
                customComponent={CustomComponent}
            />
        </div>
    )
}

export default ThongTinRaVien